import { observer } from "mobx-react"
import {
  Page,
  Header,
  DocumentTemplate,
  useStore,
  Footer,
  PureLogo,
} from "@features/common"
import { SecurityLogo } from "@features/security"
import { RichContentView } from "@ui"
import { serverSidePagePrepare } from "@lib/hooks"
import { scrollToTop } from "@lib/scroll"
import { RouterLink } from "@lib/routing"
import { IconHamburger } from "@lib/icons"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models }) => {
    await Models.GlobalModel.getSecurity()
  },
})

const SecurityPage = observer(function SecurityPage() {
  const {
    GlobalModel: { security: securities, getTemplate, openMenu },
  } = useStore()

  const title = getTemplate("menu.security")
  const metaTitle = getTemplate("security.metaTitle") || title
  const description = getTemplate("security.metaDescription")
  const seoH1 = getTemplate("seoH1.title.security")

  return (
    <Page
      meta={{
        title,
        metaTitle,
        description,
      }}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/security"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                <SecurityLogo />
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      seoH1={seoH1}
      footer={<Footer chinese />}
    >
      <div className="container pt-3 pb-15 laptop:pt-8 laptop:pb-20">
        <DocumentTemplate>
          <section className="space-y-10" id="scrollContainerElement">
            {securities.map((security) => (
              <RichContentView
                key={`security-${security.id}`}
                src={security.description}
              />
            ))}
          </section>
        </DocumentTemplate>
      </div>
    </Page>
  )
})

export default SecurityPage
